import { render } from "./edit-supplier.vue?vue&type=template&id=69e3193d&scoped=true"
import script from "./edit-supplier.vue?vue&type=script&lang=js"
export * from "./edit-supplier.vue?vue&type=script&lang=js"

import "./edit-supplier.vue?vue&type=style&index=0&id=69e3193d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e3193d"]])

export default __exports__